import { root_props } from '../main';
import {getLocalObj, setLocalObj} from "./storage";
import axios from "ts-axios-new";


export const fallback_product_list = [{
    icon: "https://play-lh.googleusercontent.com/xIEHzYUCQZdlXgP5qOntqNWEhN3S1Mb23ECMxN2zGWAlP1Q0RWJo8u0oIA6GX4e42R4=s96-rw",
    avatar: "https://play-lh.googleusercontent.com/xIEHzYUCQZdlXgP5qOntqNWEhN3S1Mb23ECMxN2zGWAlP1Q0RWJo8u0oIA6GX4e42R4=s96-rw",
    name: "Fantasy Jigsaw",
    key: "fantasy",
    features: {}
}, {
    icon: "https://play-lh.googleusercontent.com/mQGhErXbGlD93gMJhp2imkhkpzMwgkmTNR0R3lpJIYF66N53_kou80H6JUcQoCJmPOZ6GWxL_FEEkBMstxtD=w240-h480-rw",
    avatar: "https://play-lh.googleusercontent.com/mQGhErXbGlD93gMJhp2imkhkpzMwgkmTNR0R3lpJIYF66N53_kou80H6JUcQoCJmPOZ6GWxL_FEEkBMstxtD=w240-h480-rw",
    name: "Legacy Jigsaw",
    key: "classic",
    features: {}
}, {
    icon: "https://play-lh.googleusercontent.com/mQGhErXbGlD93gMJhp2imkhkpzMwgkmTNR0R3lpJIYF66N53_kou80H6JUcQoCJmPOZ6GWxL_FEEkBMstxtD=w240-h480-rw",
    avatar: "https://play-lh.googleusercontent.com/mQGhErXbGlD93gMJhp2imkhkpzMwgkmTNR0R3lpJIYF66N53_kou80H6JUcQoCJmPOZ6GWxL_FEEkBMstxtD=w240-h480-rw",
    name: "Peace Jigsaw",
    key: "peace",
    features: {}
}]

let product_list = [...fallback_product_list];

function normalizeProduct(product) {
    return {
        ...product,
        avatar: product.avatar || product.icon,
        icon: product.icon || product.avatar,
        features: product.features || {},
    }
}

function applyProductBranding(product) {
    if (!product) {
        return;
    }
    document.title = `${product.name} CMS`;

    let icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!icon) {
        icon = document.createElement('link');
        icon.rel = 'icon';
        document.head.appendChild(icon);
    }
    icon.href = product.avatar;
}

export function getProductList() {
    return product_list
}

export async function loadProductList() {
    try {
        const res = await axios.get('/cms/v1/app', {params: {include_disabled: false}});
        const apps = (res.data.data.appList || []).map(normalizeProduct);
        if (apps.length) {
            product_list = apps;
        }
    } catch (_) {
        product_list = fallback_product_list.map(normalizeProduct);
    }
    root_props.product_list = product_list;
    const current = root_props.product || getLocalObj('product', null);
    if (current) {
        const matched = product_list.find(p => p.key === current.key);
        if (matched) {
            changeProduct(matched);
            return product_list;
        }
    }
    changeProduct(product_list[0]);
    return product_list;
}

export function getProduct() {
    if (root_props.product) {
        applyProductBranding(root_props.product)
        return root_props.product
    } else {
        let product = getLocalObj('product', null);
        if (!product) {
            product = product_list[0]
            setLocalObj('product', product)
        }
        root_props.product = product
        applyProductBranding(root_props.product)
        return root_props.product
    }
}

export function changeProduct(p) {
    root_props.product = p
    setLocalObj('product', p);
    applyProductBranding(root_props.product)
    return root_props.product
}
